import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../../routes/createPathParameter';
import { okResponse, notFoundResponse } from '../../../routes/defaultResponses';

export const surveyVideoStreamPaths = {
    '/api/surveys/{surveyId}/videoStream': {
        get: {
            operationId: 'surveyVideoStreamControllers.getOne',
            parameters: [createPathGuidParameter('surveyId')],
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                rtmpUrl: Type.String(),
                                videoUrl: Type.String(),
                            }),
                        },
                    },
                },
                ...notFoundResponse,
            },
        },
        post: {
            operationId: 'surveyVideoStreamControllers.create',
            parameters: [createPathGuidParameter('surveyId')],
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({}),
                    },
                },
            },
            responses: {
                '200': {
                    description: 'OK',
                    content: {
                        'application/json': {
                            schema: Type.Object({ rtmpUrl: Type.String(), videoUrl: Type.String() }),
                        },
                    },
                },
            },
        },
        delete: {
            operationId: 'surveyVideoStreamControllers.delete',
            parameters: [createPathGuidParameter('surveyId')],
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({}),
                    },
                },
            },
            responses: {
                ...okResponse,
            },
        },
    },
} as const;
